import { Container, CreateTableState, Typography } from 'gu-ui-kit'
import React from 'react'
import { formatToString } from 'utils/formatMoney'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'
import styles from 'modules/Referral/List/subcomponents/List/referral-list.module.scss'

export const useTableConfig = ({ ...rest }, data = []) => {
  const tableConfig = {
    className: styles['referral-list'],
    state: {
      columnVisibility: {},
    },
    columns: [
      {
        id: 'created_at',
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: { email, created_at },
          },
        }) => (
          <Container display="flex" flexDirection={'column'}>
            <Typography
              variant={'p7'}
              className={styles['referral-row__email']}
            >
              {email}
            </Typography>
            <Typography variant={'p9'} noMargin color={'text-secondary'}>
              {format(parse(created_at, 't', new Date()))}
            </Typography>
          </Container>
        ),
      },
      {
        id: 'referrer_award_amount',
        cell: ({
          row: {
            original: {
              referrer_award_amount: { amount, currency },
            },
          },
        }) => formatToString(amount, currency),
      },
    ],
    showHeader: false,
    showFooter: false,
    ...rest,
  }

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
